module.exports = __webpack_public_path__ + "static/media/Saira-Medium.c5d3604b.ttf";